// Quantity add-ons get a number selector; everything else (on/off, and
// binary/toggle quantity handles) gets a switch — mirrors PlanCard's
// isQuantityControl() (components/Billing/PlanCard/index.jsx).
export function isQuantityControl (addOn) {
    const type = addOn.type || '';
    const handle = addOn.handle || '';
    const isQuantityType = type === 'quantity' || type === 'quantity_based_component';
    const isToggleHandle = handle.indexOf('binary') !== -1 || handle.indexOf('toggle') !== -1;
    return isQuantityType && !isToggleHandle;
}

// Mirrors PlanCard's buildDefaults() (components/Billing/PlanCard/index.jsx) —
// seeds quantity add-ons to 0 and toggles to false so their controls never
// render with an unmatched/undefined value.
export function buildDefaults (addOns) {
    const values = {};
    addOns.forEach((addOn) => {
        values[addOn.id] = isQuantityControl(addOn) ? 0 : false;
    });
    return values;
}
